import { makeAutoObservable, runInAction } from 'mobx';

import { axiosClient } from '../config/axios-client';
import { Color } from '../model/enumeration/Color.enum';
import { PlayerColor } from '../model/PlayerColor';

const BASE_API_PATH = '/colors';

class PlayerColorStore {
  public playersColors: PlayerColor[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public updatePlayerColor = (pid: string, color: Color): Promise<void> =>
    axiosClient
      .put<PlayerColor>(BASE_API_PATH, { pid, color })
      .then(response => response.data)
      .then(response => {
        const isPresent = this.playersColors.some(
          playerColor => playerColor.pid === response.pid,
        );
        runInAction(() => {
          if (isPresent) {
            this.playersColors = this.playersColors.map(playerColor =>
              playerColor.pid === response.pid ? response : playerColor,
            );
          } else {
            this.playersColors = [...this.playersColors, response];
          }
        });
      });

  public getPlayerColor = (pid: string): string => {
    const playerColor = this.playersColors.find(
      playerColor => playerColor.pid === pid,
    );
    return playerColor?.color ?? Color.UNSET;
  };

  public deletePlayerColor = (pid: string): Promise<void> =>
    axiosClient.delete(`${BASE_API_PATH}/${pid}`).then(() => {
      runInAction(() => {
        this.playersColors = this.playersColors.filter(
          playerColor => playerColor.pid !== pid,
        );
      });
    });

  public initPlayersColors = (): void => {
    axiosClient
      .get<PlayerColor[]>(BASE_API_PATH)
      .then(response => response.data)
      .then(response => {
        runInAction(() => {
          this.playersColors = response;
        });
      });
  };
}

const playerColorStore = new PlayerColorStore();
export default playerColorStore;
